<!-- Login Page -->
<ngx-loading [show]="loading"></ngx-loading>

<section class="login-body">
    <div class="login-div">
        <!-- <div class="logo"></div> -->
        <div class="title">Sign in</div>
        <div class="fields">
            <form [formGroup]="logInFormGroup" (ngSubmit)="onLogin()">
                <div class="username">
                    <svg class="svg-icon" viewBox="0 0 20 20">
                        <path
                            d="M15.573,11.624c0.568-0.478,0.947-1.219,0.947-2.019c0-1.37-1.108-2.569-2.371-2.569s-2.371,1.2-2.371,2.569c0,0.8,0.379,1.542,0.946,2.019c-0.253,0.089-0.496,0.2-0.728,0.332c-0.743-0.898-1.745-1.573-2.891-1.911c0.877-0.61,1.486-1.666,1.486-2.812c0-1.79-1.479-3.359-3.162-3.359S4.269,5.443,4.269,7.233c0,1.146,0.608,2.202,1.486,2.812c-2.454,0.725-4.252,2.998-4.252,5.685c0,0.218,0.178,0.396,0.395,0.396h16.203c0.218,0,0.396-0.178,0.396-0.396C18.497,13.831,17.273,12.216,15.573,11.624 M12.568,9.605c0-0.822,0.689-1.779,1.581-1.779s1.58,0.957,1.58,1.779s-0.688,1.779-1.58,1.779S12.568,10.427,12.568,9.605 M5.06,7.233c0-1.213,1.014-2.569,2.371-2.569c1.358,0,2.371,1.355,2.371,2.569S8.789,9.802,7.431,9.802C6.073,9.802,5.06,8.447,5.06,7.233 M2.309,15.335c0.202-2.649,2.423-4.742,5.122-4.742s4.921,2.093,5.122,4.742H2.309z M13.346,15.335c-0.067-0.997-0.382-1.928-0.882-2.732c0.502-0.271,1.075-0.429,1.686-0.429c1.828,0,3.338,1.385,3.535,3.161H13.346z">
                        </path>
                    </svg>
                    <mat-form-field>
                        <mat-label>Email id</mat-label>
                        <input matInput formControlName="emailId" [disabled]="loading" class="user-input" required>
                        <mat-error
                            *ngIf="logInFormGroup.controls.emailId.invalid && (logInFormGroup.controls.emailId.dirty || logInFormGroup.controls.emailId.touched)">
                            {{getErrorMsgForLoginFormEmail()}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="password">
                    <svg class="svg-icon" viewBox="0 0 20 20">
                        <path
                            d="M17.308,7.564h-1.993c0-2.929-2.385-5.314-5.314-5.314S4.686,4.635,4.686,7.564H2.693c-0.244,0-0.443,0.2-0.443,0.443v9.3c0,0.243,0.199,0.442,0.443,0.442h14.615c0.243,0,0.442-0.199,0.442-0.442v-9.3C17.75,7.764,17.551,7.564,17.308,7.564 M10,3.136c2.442,0,4.43,1.986,4.43,4.428H5.571C5.571,5.122,7.558,3.136,10,3.136 M16.865,16.864H3.136V8.45h13.729V16.864z M10,10.664c-0.854,0-1.55,0.696-1.55,1.551c0,0.699,0.467,1.292,1.107,1.485v0.95c0,0.243,0.2,0.442,0.443,0.442s0.443-0.199,0.443-0.442V13.7c0.64-0.193,1.106-0.786,1.106-1.485C11.55,11.36,10.854,10.664,10,10.664 M10,12.878c-0.366,0-0.664-0.298-0.664-0.663c0-0.366,0.298-0.665,0.664-0.665c0.365,0,0.664,0.299,0.664,0.665C10.664,12.58,10.365,12.878,10,12.878">
                        </path>
                    </svg>
                    <mat-form-field>
                        <mat-label>Password</mat-label>
                        <input matInput id="password" type="password" [disabled]="loading" formControlName="password" class="pass-input" showHideInput
                            required>
                        <span class="material-icons eye-icon" showHideTrigger="password"
                            [showHideStatus]="{ materialIcon: true, id: 'password' }"></span>
                        <mat-error
                            *ngIf="logInFormGroup.controls.password.invalid && (logInFormGroup.controls.password.dirty || logInFormGroup.controls.password.touched)">
                            {{getErrorMsgForLoginFormPassword()}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <button class="signin-button">SIGN IN</button>
                <div *ngIf="loading" class="loading">Logging in...</div>
            </form>
        </div>
        <div class="link">Don't have an account? &nbsp;<a routerLink="/signup">Sign up</a></div>
        <div class="link">Forgot password ? &nbsp;<a routerLink="/forgotPassword">Reset password</a></div>
    </div>
</section>
<!-- End Of Login Page -->






